import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { vaccinationService } from '../services/apiServices';

export const VACCINATION_KEYS = {
  all: ['vaccinations'] as const,
  alerts: () => [...VACCINATION_KEYS.all, 'alerts'] as const,
  schedule: () => [...VACCINATION_KEYS.all, 'schedule'] as const,
};

export const useVaccinationSchedule = () => {
  return useQuery({
    queryKey: VACCINATION_KEYS.schedule(),
    queryFn: () => vaccinationService.getSchedule(),
  });
};

export const useVaccinationAlerts = () => {
  return useQuery({
    queryKey: VACCINATION_KEYS.alerts(),
    queryFn: () => vaccinationService.getAlerts(),
  });
};

export const useMarkVaccinationCompleted = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      procurementId,
      vaccinationKey,
      deliveryDate,
    }: {
      procurementId: number;
      vaccinationKey: string;
      deliveryDate: string;
    }) => vaccinationService.markCompleted(procurementId, vaccinationKey, deliveryDate),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: VACCINATION_KEYS.alerts() });
    },
  });
};
